import React from "react";
import InstrumentInstallationTable from "./InstrumentInstallationTable";
import {Card} from "react-bootstrap";
import InstrumentInstallationSelector from "./InstrumentInstallationSelector";
import NewInstrumentSelector from "./NewInstrumentSelector";

function InstrumentInstallationSection(props) {
    return (
        <div className="mb-3">
            <label className="form-label">Prístroje</label>
            {props.data.Pristroje.map((item, ndx) => (
                <div className="mb-3">
                    <Card border={"muted"} bg={"light"}>
                        <div className="m-lg-3">
                            <InstrumentInstallationTable empty={false} unpackSection={true}
                                                    selectInstrument={props.selectInstrument}
                                                    instrument={item} instrumentIndex={ndx}
                                                    data={props.data}
                                                    deleteInstrument={props.deleteInstrument}
                                                    unpackable={false}
                            />
                        </div>
                    </Card>
                </div>
            ))}
            <InstrumentInstallationSelector value=""
                                            selectInstrument={props.selectInstrument}
                                            optionDisplay="SNR"
                                            ndx={props.ndx}
                                            index={null}
                                            stateResetOnChange={true}
                                            data={props.data}
                                            empty={true}
            />
            <NewInstrumentSelector addInstrument={props.addInstrument} products={props.data.Produkt_options}/>
        </div>
    )
}

export default InstrumentInstallationSection
